import { hasPermission, PERMISSIONS, type Permission } from '@repo/contracts';

import { APP_PERMISSIONS } from '@/constants/app-permissions';

/**
 * Every action here starts from a person's page, so finding people is the
 * precondition: `role:manage` without `user:read` would open an app whose only
 * reachable screen is the read-only catalogue.
 */
export const hasAppAccess = (permissions: readonly Permission[]): boolean =>
  hasPermission(permissions, [PERMISSIONS.userRead]) &&
  APP_PERMISSIONS.some((permission) => hasPermission(permissions, [permission]));
